import { useEffect, useState } from 'react';
import '../../../style/account.css';
import { sendPasswordResetEmail } from 'firebase/auth';
import { toast } from 'react-toastify';
import { auth } from '../../../firebase-functions/config';
import { updateDocument } from '../../../firebase-functions/database';
import { PopUpAreYouSure } from '../../utils/PopUpAreYouSure';
import '../../../style/utils.css';
import { logout } from '../../../firebase-functions/auth';
import { IconsRow, RoomIcons } from '../SignUpSteps.jsx/RoomIcons';
import { AvatarView } from './AvatarView';
import { IoSettings } from 'react-icons/io5';
import { IoIosCheckbox } from 'react-icons/io';
import { MdCheckBoxOutlineBlank } from 'react-icons/md';

const AnnouncementItemCard = ({
  item,
  selectedAnnouncemetTheme,
  setSelectedAnnouncementTheme,
  setAnnouncementSettings,
  oldSettings,
}) => {
  let tempOldSettings = { ...oldSettings };
  tempOldSettings.active = item.name;
  const updateAnnouncement = () => {
    updateDocument(
      'students',
      auth.currentUser.uid,

      { annoncementSetting: tempOldSettings },
      auth.currentUser,
    ).then((res) => {
      if (!res.success) {
        toast.error(
          "Something went wrong. Couldn't update the announcement Theme",
        );
        return;
      }
      toast.success('Announcement Theme Updated Successfully!');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  };
  return (
    <div
      style={{
        width: '100px',
        height: '150px',
        backgroundColor:
          selectedAnnouncemetTheme === item.name ? '#fff' : '#eee',
        cursor: 'pointer',
        padding: '5px',
      }}
      onClick={() => {
        setSelectedAnnouncementTheme(item.name);
        setAnnouncementSettings(false);
        updateAnnouncement();
      }}>
      {selectedAnnouncemetTheme === item.name ? (
        <IoIosCheckbox />
      ) : (
        <MdCheckBoxOutlineBlank />
      )}
      <img
        src={item.src}
        alt={'imgage-' + item.name}
        style={{
          width: '95px',
          height: 'auto',
        }}
      />
      {item.name}
    </div>
  );
};

export const Account = (props) => {
  const [name, setName] = useState('');
  const [league, setLeague] = useState('');

  const [popUpUpChangeLeague, setPopUpUpChangeLeague] = useState(false);
  const [popUpChangeName, setPopUpChangeName] = useState(false);
  const [popUpResetPassword, setPopUpResetPassword] = useState(false);
  const [toggleAnnouncements, setToggleAnnouncements] = useState(null);
  const [annoncementSetting, setAnnouncementSetting] = useState(null);
  const [toggleAnnouncementSettings, setAnnouncementSettings] = useState(false);

  const [selectedAnnouncemetTheme, setSelectedAnnouncementTheme] =
    useState(null);

  const [pet, setPet] = useState();
  const [color, setColor] = useState();
  const [car, setCar] = useState();

  const [tempPet, setTempPet] = useState();
  const [tempCar, setTempCar] = useState();
  const [tempColor, setTempColor] = useState();

  const handleClick = (tag, val) => {
    if (tag === 'pet') {
      if (!tempPet) {
        setTempPet(val);
      } else {
        setTempPet();
      }
    } else if (tag === 'car') {
      if (!tempCar) {
        setTempCar(val);
      } else {
        setTempCar();
      }
    } else if (tag === 'color') {
      if (!tempColor) {
        setTempColor(val);
      } else {
        setTempColor();
      }
    }
  };

  const handleSaveIcons = () => {
    if (!tempPet) {
      toast.error('Please Select a Pet');
      return;
    }
    if (!tempCar) {
      toast.error('Please Select a Car');
      return;
    }
    if (!tempColor) {
      toast.error('Please Select a Color');
      return;
    }
    setPet(tempPet);
    setCar(tempCar);
    setColor(tempColor);

    updateDocument(
      'students',
      auth.currentUser.uid,
      {
        pet: tempPet,
        car: tempCar,
        color: tempColor,
      },
      auth.currentUser,
    ).then((res) => {
      if (res.success) {
        toast.success('Icons changed successfully');
      }
    });
  };

  useEffect(() => {
    props?.readerProfile && setName(props?.readerProfile.name);
    setPet(props?.readerProfile.pet);
    if (props.studentInfo && props.studentInfo.annoncementSetting) {
      setAnnouncementSetting(props.studentInfo.annoncementSetting);
      setToggleAnnouncements(props.studentInfo.annoncementSetting.value);
    } else {
      setToggleAnnouncements(true);
    }
  }, [props?.readerProfile]);

  useEffect(() => {
    props?.studentInfo && setPet(props?.studentInfo.pet);

    if (props?.studentInfo?.annoncementSetting?.active) {
      setSelectedAnnouncementTheme(
        props?.studentInfo?.annoncementSetting.active,
      );
    } else {
      setSelectedAnnouncementTheme('Default');
    }
  }, [props?.studentInfo]);

  const handleSendResetEmail = async () => {
    try {
      await sendPasswordResetEmail(auth, auth.currentUser.email);
      toast.success('Reset Password Link Sent To Your Email!');
    } catch (error) {
      toast.error('Error sending password reset email:', error.message);
    }
  };

  const handleChangeName = () => {
    if (name.length < 3) {
      toast.error('The name should be at least 3 letters long');
      return;
    }

    updateDocument(
      'students',
      auth.currentUser.uid,
      {
        name: name,
      },
      auth.currentUser,
    ).then((res) => {
      if (res.success) {
        toast.success('Name changed successfully');
      }
    });
    updateDocument(
      props?.readerProfile?.type === 'demo' ? 'demoReaders' : 'readers',
      props?.readerProfile?.id,

      {
        name: name,
      },
      auth.currentUser,
    ).then((res) => {
      if (res.success) {
        toast.success('Name changed successfully');
      }
    });
  };

  const handleLogout = () => {
    logout().then((res) => {
      if (res.success) {
        toast.success('logged out successfully');
        setTimeout(() => {
          window.location.replace('/login');
        }, 500);
      } else {
        toast.error('Something went horribly wrong');
      }
    });
  };

  const handleOptInOutAnnouncements = () => {
    const tempToggle = !toggleAnnouncements;
    setToggleAnnouncements(tempToggle);

    const tempData = {
      annoncementSetting: {
        value: tempToggle,
        updatedAt: new Date().toISOString(),
      },
    };
    updateDocument(
      'students',
      auth.currentUser.uid,
      tempData,
      auth.currentUser,
    ).then((res) => {
      if (res.success) {
        toast.success(
          `You have successfully ${
            tempToggle ? 'opted in to' : 'opted out of'
          } announcements`,
        );
        setAnnouncementSetting(tempData.annoncementSetting);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    });
  };

  return (
    <div className='container account-container'>
      <h2>Account</h2>
      <div className='div-profile-pic'>
        <AvatarView avatarInfo={props?.studentInfo?.avatar} />
      </div>
      <div className='table-container'>
        <div className='form-line'>
          <label htmlFor='name'>Name</label>
          <input
            type='text'
            name='name'
            value={name}
            maxLength={10}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          {name !== props.studentInfo.name && (
            <button
              onClick={() => {
                setPopUpChangeName(true);
              }}>
              Save
            </button>
          )}
        </div>

        <div className='form-line'>
          <label htmlFor='room-icons'>Room Icon</label>

          <IconsRow pet={pet} />
        </div>

        <div className='form-line'>
          <label htmlFor='league'>League</label>

          <select name='league' id='league' value={league} disabled>
            <option value='league-1'>League 1</option>
            <option value='league-2'>League 2</option>
            <option value='league-3'>League 3</option>
            <option value='league-4'>League 4</option>
          </select>
          {league !== props.readerProfile.league && false && (
            <button onClick={() => setPopUpUpChangeLeague(true)}>Save</button>
          )}
        </div>
        <br />
        <div
          className='form-checkbox'
          style={{
            position: 'relative',
          }}>
          <input
            type='checkbox'
            checked={toggleAnnouncements}
            defaultChecked={toggleAnnouncements}
            // disable updates if the changes happened within the last 24 hours
            disabled={
              annoncementSetting &&
              new Date().getTime() -
                new Date(annoncementSetting.updatedAt).getTime() <
                24 * 60 * 60 * 1000
            }
            // onChange={handleOptInOutAnnouncements}
            onChange={handleOptInOutAnnouncements}
          />
          <label htmlFor='league'>
            Reading Announcements{' '}
            {annoncementSetting &&
              new Date().getTime() -
                new Date(annoncementSetting.updatedAt).getTime() <
                24 * 60 * 60 * 1000 &&
              annoncementSetting &&
              new Date().getTime() -
                new Date(annoncementSetting.updatedAt).getTime() >
                0 && (
                <span style={{ fontSize: '0.8rem', color: 'gray' }}>
                  (You can change this setting again on{' '}
                  {new Date(
                    new Date(annoncementSetting.updatedAt).getTime() +
                      24 * 60 * 60 * 1000,
                  ).toLocaleString()}
                  )
                </span>
              )}
          </label>

          <button
            style={{
              width: '30px',
              backgroundColor: '#555c',
              padding: '5px',
              fontSize: '15px',
              height: '30px',
              margin: 'auto 0',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={() => {
              setAnnouncementSettings(true);
            }}>
            <IoSettings />
          </button>

          {toggleAnnouncementSettings && (
            <div
              className='announcement-settings'
              style={{
                position: 'absolute',
                left: '20%',
                top: '-140px',
                zIndex: '10000',
                backgroundColor: '#eee',
                padding: '10px',
                height: '150px',
                width: '400px',
                display: 'flex',
                justifyContent: 'baseline',
                flexWrap: 'nowrap',
                gap: '10px',
                overflowX: 'scroll',
              }}>
              <div className='announcement-theme-item'>
                {
                  <AnnouncementItemCard
                    item={{
                      name: 'Default',
                      src: 'https://static.thenounproject.com/png/2616533-200.png',
                    }}
                    selectedAnnouncemetTheme={selectedAnnouncemetTheme}
                    setSelectedAnnouncementTheme={setSelectedAnnouncementTheme}
                    setAnnouncementSettings={setAnnouncementSettings}
                    oldSettings={props.studentInfo.annoncementSetting || {}}
                  />
                }
              </div>
              {props.readerProfile?.themeInventory?.map((item) => (
                <div className='announcement-theme-item' key={item.name}>
                  {
                    <AnnouncementItemCard
                      item={item}
                      selectedAnnouncemetTheme={selectedAnnouncemetTheme}
                      setSelectedAnnouncementTheme={
                        setSelectedAnnouncementTheme
                      }
                      setAnnouncementSettings={setAnnouncementSettings}
                      oldSettings={props.studentInfo.annoncementSetting || {}}
                    />
                  }
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className='form-line form-logout'>
        <button
          onClick={() => {
            handleLogout();
          }}>
          Logout
        </button>
      </div>

      {popUpUpChangeLeague && (
        <PopUpAreYouSure
          question='This feature is coming soon'
          setPopUp={setPopUpUpChangeLeague}
          cancel={() => {
            setPopUpUpChangeLeague(false);
          }}
          // proceedFunction={handleChangeLeague}
          proceedMessage="Won't work"
          cancelMessage='Cancel'
        />
      )}
      {popUpChangeName && (
        <PopUpAreYouSure
          question='Are you sure you want to change your name?'
          setPopUp={setPopUpChangeName}
          proceedFunction={handleChangeName}
          proceedMessage='Change'
          cancelMessage='Cancel'
        />
      )}
      {popUpResetPassword && (
        <PopUpAreYouSure
          question='Send Reset Password?'
          setPopUp={popUpResetPassword}
          proceedFunction={handleSendResetEmail}
          proceedMessage='Change'
          cancelMessage='Cancel'
        />
      )}
    </div>
  );
};
